import { Volume2 } from 'lucide-react';
import { useState } from 'react';
import { useWarningAudio } from '../hooks/useWarningAudio';
import { Button } from './Button';

export function WarningSoundControl() {
  const audio = useWarningAudio();
  const [testFailed, setTestFailed] = useState(false);

  async function testSound() {
    setTestFailed(!(await audio.test()));
  }

  return (
    <div className="rounded-md border border-slate-200 p-4 dark:border-slate-700">
      <p className="text-sm font-semibold">Warning sound: <span className="capitalize">{audio.status}</span></p>
      <Button className="mt-3" variant="secondary" icon={<Volume2 className="h-4 w-4" />} onClick={() => void testSound()}>
        Test warning sound
      </Button>
      {testFailed ? <p role="status" className="mt-2 text-sm text-amber-300">Sound could not be enabled. Check browser autoplay settings and device volume.</p> : null}
    </div>
  );
}
